function withTimestamp(data) {
    return {
        ...data,
        updated_at: new Date().toISOString(),
    };
}
export function withUpdateTimestamp(data) {
    return withTimestamp(data);
}
export function withCreateTimestamp(data) {
    return withTimestamp(data);
}
//# sourceMappingURL=timestamp-helper.js.map